var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"render"},[_c('app-page',{attrs:{"editor-mode":false}}),_c('div',{staticClass:"status-pixel",class:_vm.getLoadClass,attrs:{"data-rendered-time":_vm.getLoadTime}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }